import React, { Component, Fragment } from "react";
import { Container, Row, Col, Table } from "reactstrap";
import moment from "moment";
import BlockIcon from "@material-ui/icons/Block";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ListAltIcon from "@material-ui/icons/ListAlt";
import SaveIcon from "@material-ui/icons/Save";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ModalHistory from "../ClinicHistoryComplete/Components/ModalHistory";
import {
  faProcedures,
  faCrutch,
  faWheelchair,
  faHeadSideCough,
  faPlusSquare,
  faAmbulance,
  faLungs,
  faPencilAlt,
  faDisease,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { calculateAgeParse } from "../../Utils/Patient";
import {
  Modal,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  withStyles,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import pdfClincHistory from "../../ClinicHistory/ClinicEvent/components/PdfReports/PdfHistory";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import FormEspecialReq from "../../Admissions/AddAdmission/components/FormEspecialReq";
import FormFallingRisks from "../../Admissions/AddAdmission/components/FormFallingRisks";
import EditSpecialRequerimets from "../../../shared/components/EditSpecialRequerimets";
import AlergiesListToShow from "../../Patient/DisplayPatientInformation/components/alergies/components/AlergiesListToShow";

const MedicalCheckbox = withStyles({
  root: {
    "&$checked": {
      color: "#4ce1b6",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#84ffe7",
      main: "#49e0b5",
      dark: "#00ad85",
      contrastText: "#fff",
      height: "10px",
    },
  },
});

class PatientInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sender: this.props.remitente != null ? this.props.remitente : "",
      photo: `${process.env.PUBLIC_URL}/img/man-1280.png`,
      services:
        this.props.servicios != null || this.props.servicios != undefined
          ? this.props.servicios
          : this.props.servicio != null || this.props.servicio != undefined
          ? this.props.servicio
          : null,
      showMoreServices: false,
      editweigt_height: false,
      showClinicHistoryComplete: false,
      listTipos: JSON.parse(sessionStorage.getItem("centroTipos")),
      id_admision:
        this.props.id_admision !== null || this.props.id_admision !== undefined
          ? this.props.id_admision
          : "",
      disabledInput: false,
      disableEspReqForm: false,
      requerimientos_especiales: {
        hospitalizado: false,
        sillas: false,
        muletas: false,
        sintomas_respiratorios: false,
        oxigeno: false,
        camilla: false,
        ambulancia: false,
        ninguno: false,
        otro: false,
        otroReq: "",
      },
      caidas: {
        caida_previa: "",
        medicamentos: "",
        def_sensoriales: "",
        estado_mental: "",
        deambulacion: "",
        valor: 0,
        riesgo: "",
        fecha_hora: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
      },
      edit_reqEspeciales: false,
      editFallingRisks: false,
      openAlert: false,
      modalAlert: { message: "", color: "", title: "" },
      admissions: [],
      today: new Date(),
      urlLogo: sessionStorage.getItem("logoURL"),
      ordenes: [],
      profile: [],
      professional: [],
      civilStatus: "",
      bloodType: "",
      clinicalStudioInfo: null,
      openModalAlergies: false,
      colorStateFallingRisks: "#6F6964",
      firmTech: "",
      firmDoctor: "",
      fullnameDoctor: "",
      fullnameTech: "",
      medicoApoyo: "",
      firmDoctorGet: "",
      firmDoctorSupport: "",
      occupation: null,
      disability: null,
      poblacionVulnerable: null,
      telephone: "",
      cellphone: ""
    };
  }

  componentDidMount() {
    if (
      this.props.requerimientos_especiales !== undefined &&
      this.props.riesgo_caidas !== undefined
    ) {
      this.setState(
        { requerimientos_especiales: this.props.requerimientos_especiales },
        () => {
          if (this.state.requerimientos_especiales.ninguno == true)
            this.setState({ disableEspReqForm: true });
        }
      );
    }
    if (
      this.props.riesgo_caidas !== undefined &&
      this.props.riesgo_caidas !== null
    ) {
      this.setState({ caidas: this.props.riesgo_caidas }, () =>
        this.verifyColorRisk()
      );
    }
    this.getPrintEvent();
    this.getClinicHistory();
    this.loadDataProfile();
    console.log("llego pacientes",this.props.infoPatient);
    
  }

  handlerShowClinicHistoryComplete = (showClinicHistory) => {
    this.setState({ showClinicHistoryComplete: showClinicHistory });
  };

  setReqHospitalizado = (chkHospitalizad) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        hospitalizado: chkHospitalizad,
      },
    });
  };

  setReqSillas = (chkSillas) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        sillas: chkSillas,
      },
    });
  };

  setReqMuletas = (chkMuletas) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        muletas: chkMuletas,
      },
    });
  };

  setReqSintomas = (chkSintoma) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        sintomas_respiratorios: chkSintoma,
      },
    });
  };

  setReqOxigeno = (chkOxigeno) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        oxigeno: chkOxigeno,
      },
    });
  };

  setReqCamilla = (chkCamilla) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        camilla: chkCamilla,
      },
    });
  };

  setReqAmbulancia = (chkAmbulancia) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        ambulancia: chkAmbulancia,
      },
    });
  };

  setReqNinguno = (chkNinguno) => {
    console.log("STATE", chkNinguno);
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        ninguno: chkNinguno,
      },
    });
    if (chkNinguno == false) {
      this.setState({ disableEspReqForm: false });
    } else {
      this.setState({ disableEspReqForm: true });
      this.setState(
        {
          requerimientos_especiales: {
            ...this.state.requerimientos_especiales,
            hospitalizado: false,
            sillas: false,
            muletas: false,
            sintomas_respiratorios: false,
            oxigeno: false,
            camilla: false,
            ambulancia: false,
            ninguno: chkNinguno,
            otro: false,
            otroReq: "",
          },
        },
        () => console.log("STATEREQ", this.state.requerimientos_especiales)
      );
    }
  };

  setReqOtro = (chkOtro) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        otro: chkOtro,
      },
    });
  };

  setReqOtroReq = (chkOtroReq) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        otroReq: chkOtroReq,
      },
    });
  };

  handlerDisableEspReqForm = (action) => {
    this.setState({ disableEspReqForm: action });
  };

  handlerEditSpecialReq = (event) => {
    this.setState({ edit_reqEspeciales: event, editFallingRisks: !event });
  };

  handlerEditFallingRisks = (event) => {
    this.setState({ editFallingRisks: event, edit_reqEspeciales: !event });
  };

  handlerOpenModalAlergies = (event) => {
    this.setState({ openModalAlergies: event });
  };

  setCaidaCaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          caida_previa: radioCaidaPreviaAnswer,
        },
      },
      () => {
        console.log("FALLINGRISKCHANGE", this.state.caidas);
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida2CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          medicamentos: radioCaidaPreviaAnswer,
        },
      },
      () => {
        console.log("FALLINGRISKCHANGE", this.state.caidas);
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida3CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          def_sensoriales: radioCaidaPreviaAnswer,
        },
      },
      () => {
        console.log("FALLINGRISKCHANGE", this.state.caidas);
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida4CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          estado_mental: radioCaidaPreviaAnswer,
        },
      },
      () => {
        console.log("FALLINGRISKCHANGE", this.state.caidas);
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida5CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          deambulacion: radioCaidaPreviaAnswer,
        },
      },
      () => {
        console.log("FALLINGRISKCHANGE", this.state.caidas);
        this.getRiesgoFallingRisk();
      }
    );
  };

  getRiesgoFallingRisk = () => {
    let valor = 0;
    let riesgo;

    if (this.state.caidas.caida_previa === "Sí") valor = valor + 1;

    if (this.state.caidas.medicamentos === "Sí") valor = valor + 1;

    if (
      this.state.caidas.def_sensoriales === "Alteraciones Visuales, Auditivas"
    )
      valor = valor + 1;

    if (this.state.caidas.estado_mental === "Confuso") valor = valor + 1;

    if (this.state.caidas.deambulacion === "No") valor = valor + 1;

    if (valor >= 3) {
      riesgo = "Alto";
    } else if (valor == 2) {
      riesgo = "Medio";
    } else {
      riesgo = "Bajo";
    }

    this.setState(
      {
        caidas: {
          caida_previa: this.state.caidas.caida_previa,
          medicamentos: this.state.caidas.medicamentos,
          def_sensoriales: this.state.caidas.def_sensoriales,
          estado_mental: this.state.caidas.estado_mental,
          deambulacion: this.state.caidas.deambulacion,
          valor: valor,
          riesgo: riesgo,
          fecha_hora: this.state.caidas.fecha_hora,
        },
      },
      () => this.verifyColorRisk()
    );

    return riesgo;
  };

  getClinicHistory = async () => {
    let id_historia = parseInt(this.props.infoPatient.id_historia);
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "evento/consultar/historia_clinica/" +
        id_historia,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("datos...", data.paciente);
        this.setState({ admissions: data.admisiones });
        this.setState({ disability: data.paciente });
        this.setState({ poblacionVulnerable: data.paciente?.nombre });
        this.setState({ telephone: data.paciente.telefono1 });
        this.setState({ cellphone: data.paciente.celular });
        
      })
      .catch((error) => {
        alert(error);
        console.error("Error:", error);
      });
  };

  getPrintEvent = async () => {
    let id_historia = parseInt(this.props.infoPatient.id_historia);
    let id_admision = parseInt(this.props.id_admision);

    const dataSend = { id_historia: id_historia, id_admision: id_admision };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "evento/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("evento/consultar", data);
        //this.setDataClinicEvent(data);
        this.setState({
          ordenes: data.contenido.ordenes,
          professional: data.contenido.profesional,
          bloodType: data.contenido.pacientes.tipo_sangre,
          civilStatus: data.contenido.pacientes.e_civil,
        });
      })
      .catch((error) => {
        alert(error);
        console.error("Error:", error);
      });
  };

  loadDataProfile = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "clinica/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          this.setState({
            profile: data[0],
            //urlLogo: process.env.REACT_APP_PUBLIC_URL + "clinica/" + data[0].id_clinica + "/logo/" + sessionStorage.getItem('token')
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  updateReqEsp = () => {
    let data = {
      id_admision: this.state.id_admision,
      requerimientos_especiales: this.state.requerimientos_especiales,
    };
    fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision/actualizar-requerimientos-especiales",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(response.json());
        }
      })
      .then((data) => {
        //setDisableFormAdm(true)
        //setEditReqEsp(false)
        this.setState({
          openAlert: true,
          edit_reqEspeciales: false,
          modalAlert: {
            message: "Req. Especiales actualizados con exito",
            color: "success",
            title: "Exitoso!",
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  updateFallingRisk = async () => {
    let data = {
      id_admision: this.state.id_admision,
      caidas: this.state.caidas,
    };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision/actualizar-riesgo-caida",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(response.json());
        }
      })
      .then((data) => {
        this.setState({ editFallingRisks: false });
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Riesgo de Caida",
            message: "Riesgo de Caida actualizada con éxito",
            color: "success",
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDataFirm = async () => {
    console.log(this.state.id_admision);
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision/consultar-firmas?id_admision=" +
        this.state.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.firmas != null && data.firmas != undefined) {
          console.log("datafirma", data.firmas);
          let url_doctor =
            process.env.REACT_APP_PUBLIC_URL +
            data.firmas.url_firma_doctor +
            "/" +
            sessionStorage.getItem("token");
          let url_tecnologo =
            process.env.REACT_APP_PUBLIC_URL +
            data.firmas.url_tecnologo +
            "/" +
            sessionStorage.getItem("token");
          let firmDoctorSupportGet = data.firmas.medico_apoyo.map((medico) => {
            return (
              process.env.REACT_APP_PUBLIC_URL +
              medico.url_firma_doctor_alter +
              "/" +
              sessionStorage.getItem("token")
            );
          });
          this.setState({
            firmTech: url_tecnologo,
            firmDoctor: url_doctor,
            fullnameDoctor: data.firmas.nombre_doctor,
            fullnameTech: data.firmas.tecnologo_nombre,
            medicoApoyo: data.firmas.medico_apoyo,
            firmDoctorGet: data.firmas.url_doctor,
            firmDoctorSupport: firmDoctorSupportGet,
          });
          console.log(data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  makePdfHistory = async () => {
    /* this.getPrintEvent();
        this.getClinicHistory();
        this.loadDataProfile(); */

    await this.loadDataFirm();

    const data = {
      today: this.state.today,
      urlLogo: this.state.urlLogo,
      names: this.props.infoPatient.fullname,
      day: moment(this.state.today).format("LL"),
      ordenes: this.state.ordenes,
      admissions: this.state.admissions,
      gender: this.props.infoPatient.sexo,
      address: this.props.infoPatient.adress.direccion,
      city: this.props.infoPatient.adress.ciudad,
      telephone: this.state.telephone,
      cellphone: this.state.cellphone,
      civilStatus: this.state.civilStatus,
      bloodType: this.state.bloodType,
      typeOfDocument: this.props.infoPatient.tip_documento,
      documentNumber: this.props.infoPatient.num_documento,
      profile: this.state.profile,
      age: calculateAgeParse(this.props.infoPatient.birthday),
      birthday: this.props.infoPatient.birthday,
      id_admision: this.props.id_admision,
      professional: this.state.professional,
      id_historia: parseInt(this.props.infoPatient.id_historia),
      medicoApoyo: this.state.medicoApoyo,
      firmDoctor: this.state.firmDoctor,
      firmDoctorSupport: this.state.firmDoctorSupport,
      occupation: this.props.infoPatient.ocupacion,
      disability: this.state.disability?.discapacidad,
      poblacionVulnerable: this.state.poblacionVulnerable,
    };
    /* 
                if(this.state.admissions.length > 0 && this.state.profile > 0){
                } */
    this.setState({ showClinicHistoryComplete: true });
    pdfClincHistory(data, "PDF", null);
  };

  verifyColorRisk = () => {
    if (this.state.caidas.riesgo !== "") {
      switch (this.state.caidas.riesgo) {
        case "Bajo":
          this.setState({ colorStateFallingRisks: "#00D51A" });
          break;
        case "Alto":
          this.setState({ colorStateFallingRisks: "#F71C06" });
          break;
        case "Medio":
          this.setState({ colorStateFallingRisks: "#F7EF06" });
          break;
        default:
          this.setState({ colorStateFallingRisks: "#6F6964" });
          break;
      }
    } else {
      this.setState({ colorStateFallingRisks: "#6F6964" });
    }
  };

  render() {
    const { infoPatient } = this.props;

    //console.log("infoPatient", infoPatient);
    return (
      <Fragment>
        <Row>
          <Col
            xs={8}
            md={11}
            style={{ paddingLeft: "2em" }}
            className="titles-top-info"
          >
            <Row>
              <Col md={4}>
                <h6>
                  <b>Nombre del Paciente:</b>&nbsp;
                  {this.props.refreshInfoPatient.names +
                    " " +
                    this.props.refreshInfoPatient.firstLastName +
                    " " +
                    this.props.refreshInfoPatient.secondLastName}
                </h6>
              </Col>
              <Col md={4}>
                <h6>
                  <b>Número de Documento:</b>&nbsp;
                  {this.props.refreshInfoPatient.typeOfDocument + "-"}
                  {this.props.refreshInfoPatient.documentNumber}
                </h6>
              </Col>
              <Col md={4}>
                <h6>
                  <b>Fecha de Nacimiento:</b>&nbsp;
                  {this.props.refreshInfoPatient.birthday != undefined &&
                  this.props.refreshInfoPatient.birthday != null
                    ? moment(this.props.refreshInfoPatient.birthday).format(
                        "DD/MM/YYYY"
                      )
                    : null}
                </h6>
              </Col>
              <Col md={4}>
                <div style={{ marginTop: 10 }}>
                  <h6>
                    <b>Edad:</b>&nbsp;
                    {calculateAgeParse(this.props.refreshInfoPatient.birthday)}
                  </h6>
                </div>
              </Col>
              {this.state.listTipos.includes("3") ? (
                <Fragment>
                  <Col md={4}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 10,
                      }}
                    >
                      <h6>
                        <b>Peso:</b>&nbsp;{this.props.weight} kg - <b>Talla:</b>{" "}
                        &nbsp;{this.props.height} cm - <b>IMC:</b>&nbsp;
                        {this.props.imc}
                      </h6>
                    </div>
                  </Col>
                </Fragment>
              ) : null}
              <Col md={4}>
                <div style={{ marginTop: 10 }}>
                  <h6>
                    <b>Medico Remitente:</b>&nbsp;{this.state.sender}
                  </h6>
                </div>
              </Col>
              <Col md={4}>
                <div style={{ marginTop: 10 }}></div>
                <h6>
                  <b>Entidad:</b>&nbsp;
                  {!!this.props.thirdInfo
                    ? this.props.thirdInfo.nombre
                    : ""}{" "}
                  {!!this.props.contractInfo ? (
                    <>
                      <br />
                      <b>Regimen:</b>{" "}
                      {this.props.contractInfo?.nom_regimen.toUpperCase()}
                    </>
                  ) : (
                    ""
                  )}
                </h6>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                {this.props.clinicalStudyHistory != true ? (
                  <div style={{ marginTop: 10 }}>
                    <h6>
                      <b>Servicios:</b>&nbsp;
                      {this.state.services.map((servicio, index) => {
                        if (
                          this.state.showMoreServices == false &&
                          index <= 1
                        ) {
                          return <li key={index}>{servicio.nombre}</li>;
                        } else if (this.state.showMoreServices == true) {
                          return <li key={index}>{servicio.nombre}</li>;
                        }
                      })}
                    </h6>
                    {this.state.showMoreServices == false ? (
                      <label
                        style={{ cursor: "pointer", color: "#4CE1B6" }}
                        onClick={() =>
                          this.setState({ showMoreServices: true })
                        }
                      >
                        Ver Más
                      </label>
                    ) : (
                      <label
                        style={{ cursor: "pointer", color: "#4CE1B6" }}
                        onClick={() =>
                          this.setState({ showMoreServices: false })
                        }
                      >
                        Ver Menos
                      </label>
                    )}
                    {this.state.showMoreServices == true ? (
                      <div>
                        {this.state.admissions.map((admission, index) => {
                          return (
                            <div>
                              <p style={{ fontWeight: "bold" }}>
                                PROFESIONALES:
                              </p>
                              <li
                                key={index}
                              >{`${admission.nombres} ${admission.apellido1} ${admission.apellido2}`}</li>
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                ) : null}
                <br />
              </Col>
              <Col md={4}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div style={{ padding: "0.3em 2em 0em 0em" }}>
                    <Tooltip title="Historia Clínica Completaaa">
                      <IconButton
                        aria-label="launch"
                        color="inherit"
                        style={{ padding: 2, backgroundColor: "#55e5bb" }}
                        onClick={() => {
                          this.makePdfHistory();
                          //this.handlerShowClinicHistoryComplete(true);
                        }}
                      >
                        <ListAltIcon style={{ color: "#153365" }} />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div style={{ padding: "0.3em 2em 0em 0em" }}>
                    <Tooltip title="Alergias">
                      <IconButton
                        aria-label="launch"
                        color="inherit"
                        style={{
                          padding: 2,
                          backgroundColor: this.props.colorAlergiesIcon,
                        }}
                        onClick={() => {
                          //this.makePdfHistory();
                          this.handlerOpenModalAlergies(
                            !this.state.openModalAlergies
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={faDisease} />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div>
                    <div
                      style={{
                        /* border: '1px solid #55e5bb', */ borderRadius: 50,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          padding: "0.5em 0.5em",
                        }}
                      >
                        {/* <EditSpecialRequerimets reqEspProps={this.props.requerimientos_especiales !== undefined ? this.props.requerimientos_especiales : this.state.requerimientos_especiales} idAdmision={this.state.id_admision} /> */}
                        <Tooltip title="Editar Riesgo de Caida">
                          <IconButton
                            aria-label="launch"
                            color="inherit"
                            style={{
                              padding: 2,
                              backgroundColor:
                                this.state.colorStateFallingRisks,
                              width: "1.2em",
                              height: "1.2em",
                            }}
                            disabled={this.props.stateClinicHistory}
                            onClick={() => {
                              this.handlerEditFallingRisks(
                                !this.state.editFallingRisks
                              );
                            }}
                          >
                            <EditOutlinedIcon style={{ color: "#153365" }} />
                          </IconButton>
                        </Tooltip>
                        <div>
                          {/* <p style={{ color: '#153365', padding: '0em 0.25em' }}>Riesgo de Caida:</p>
                                                    <p style={{ padding: '0em 0.25em', color: '#1086e0', margin: '0em' }}>{this.state.caidas.riesgo}</p> */}
                          <span>
                            Riesgo de caída:{" "}
                            <FontAwesomeIcon
                              icon={faCircle}
                              style={{
                                color: this.state.colorStateFallingRisks,
                              }}
                            />{" "}
                            <b>{this.state.caidas.riesgo}</b>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div
                      style={{
                        /* border: '1px solid #55e5bb', */ borderRadius: 50,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          padding: "0.5em 0.5em",
                        }}
                      >
                        <Tooltip title="Editar Requerimientos Especiales">
                          <IconButton
                            aria-label="launch"
                            color="inherit"
                            style={{
                              padding: 2,
                              backgroundColor: "#55e5bb",
                              width: "1.2em",
                              height: "1.2em",
                            }}
                            disabled={this.props.stateClinicHistory}
                            onClick={() => {
                              this.handlerEditSpecialReq(
                                !this.state.edit_reqEspeciales
                              );
                            }}
                          >
                            <EditOutlinedIcon style={{ color: "#153365" }} />
                          </IconButton>
                        </Tooltip>
                        <div>
                          <p
                            style={{ color: "#153365", padding: "0em 0.25em" }}
                          >
                            Req. Especiales:
                          </p>
                          {this.state.requerimientos_especiales
                            .hospitalizado !== false &&
                          this.state.requerimientos_especiales.hospitalizado !==
                            undefined ? (
                            <Tooltip title="Hospitalizado">
                              <IconButton style={{ padding: 0 }}>
                                <FontAwesomeIcon
                                  icon={faPlusSquare}
                                  style={{
                                    margin: "0px 5px 0px 5px",
                                    color: "#1086e0",
                                    width: "15px",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                          {this.state.requerimientos_especiales.sillas !==
                            false &&
                          this.state.requerimientos_especiales.sillas !==
                            undefined ? (
                            <Tooltip title="Sillas de ruedas">
                              <IconButton style={{ padding: 0 }}>
                                <FontAwesomeIcon
                                  icon={faWheelchair}
                                  style={{
                                    margin: "0px 5px 0px 5px",
                                    width: "15px",
                                    color: "#1086e0",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                          {this.state.requerimientos_especiales
                            .sintomas_respiratorios !== false &&
                          this.state.requerimientos_especiales
                            .sintomas_respiratorios !== undefined ? (
                            <Tooltip title="Sintomas respitarios (Covid)">
                              <IconButton style={{ padding: 0 }}>
                                <FontAwesomeIcon
                                  icon={faHeadSideCough}
                                  style={{
                                    margin: "0px 5px 0px 5px",
                                    width: "15px",
                                    color: "#1086e0",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                          {this.state.requerimientos_especiales.oxigeno !==
                            false &&
                          this.state.requerimientos_especiales.oxigeno !==
                            undefined ? (
                            <Tooltip title="Oxigeno">
                              <IconButton style={{ padding: 0 }}>
                                <FontAwesomeIcon
                                  icon={faLungs}
                                  style={{
                                    margin: "0px 5px 0px 5px",
                                    width: "15px",
                                    color: "#1086e0",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                          {this.state.requerimientos_especiales.camilla !==
                            false &&
                          this.state.requerimientos_especiales.camilla !==
                            undefined ? (
                            <Tooltip title="Camilla">
                              <IconButton style={{ padding: 0 }}>
                                <FontAwesomeIcon
                                  icon={faProcedures}
                                  style={{
                                    margin: "0px 5px 0px 5px",
                                    width: "15px",
                                    color: "#1086e0",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                          {this.state.requerimientos_especiales.ambulancia !==
                            false &&
                          this.state.requerimientos_especiales.ambulancia !==
                            undefined ? (
                            <Tooltip title="Ambulancia">
                              <IconButton style={{ padding: 0 }}>
                                <FontAwesomeIcon
                                  icon={faAmbulance}
                                  style={{
                                    margin: "0px 5px 0px 5px",
                                    width: "15px",
                                    color: "#1086e0",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                          {this.state.requerimientos_especiales.ninguno !==
                            false &&
                          this.state.requerimientos_especiales.ninguno !==
                            undefined ? (
                            <>
                              <div>
                                <p
                                  style={{
                                    padding: "0em 0.25em",
                                    color: "#1086e0",
                                  }}
                                >
                                  Ninguno
                                </p>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            {/* {
                            this.state.editFallingRisks ?
                                <FormFallingRisks propsCaidas={this.props.riesgo_caidas} idAdmision={this.state.id_admision} />
                                : null
                        } */}
          </Col>
        </Row>
        <Row>
          {this.state.editFallingRisks ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "initial",
                }}
              >
                <div style={{ marginLeft: 10, marginTop: 10 }}>
                  <h4>Riesgo de Caída</h4>
                </div>
                <div>
                  {this.state.id_admision !== null &&
                  this.state.id_admision !== undefined &&
                  this.state.id_admision !== "" ? (
                    this.state.editFallingRisks == false ? (
                      <Tooltip title="Editar Riesgo de Caida">
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          onClick={() => {
                            this.setState({ editFallingRisks: true });
                          }}
                        >
                          <EditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Actualizar Datos">
                          <IconButton
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              this.updateFallingRisk();
                            }}
                          >
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancelar Edición">
                          <IconButton
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              //this.setState({ womanInformationEdit: false });
                              this.setState({ editFallingRisks: false });
                            }}
                          >
                            <BlockIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    )
                  ) : null}
                </div>
              </div>
              <Row>
                <div className="form" style={{ flexDirection: "column" }}>
                  <div className="half">
                    <div>
                      <Table style={{ height: 70, margin: 0 }}>
                        <tbody>
                          <tr
                            style={{
                              lineHeight: 1,
                              borderTop: "1px solid #6c757d",
                            }}
                          >
                            <td
                              style={{
                                padding: 9,
                                fontSize: "1rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                fontWeight: 400,
                              }}
                            >
                              Caidas previas
                            </td>
                            <td style={{ padding: 2 }}>
                              <FormControl component="fieldset">
                                <RadioGroup
                                  aria-label="lblCaidasPrev"
                                  name="rdCaidasPrev"
                                  defaultValue={this.state.caidas.caida_previa}
                                  value={this.state.caidas.caida_previa}
                                  onChange={(e) => {
                                    this.setCaidaCaPr(e.target.value);
                                  }}
                                >
                                  <FormControlLabel
                                    value="Sí"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="Sí"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </td>
                          </tr>
                          <tr
                            style={{
                              lineHeight: 1,
                              borderTop: "1px solid #6c757d",
                            }}
                          >
                            <td
                              style={{
                                padding: 9,
                                fontSize: "1rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                fontWeight: 400,
                              }}
                            >
                              El Paciente usa medicamentos, Tranquilizantes,
                              sedantes, diuréticos, antidepresivos
                            </td>
                            <td style={{ padding: 2 }}>
                              <FormControl component="fieldset2">
                                <RadioGroup
                                  aria-label="lblMedicamentos"
                                  name="rdMedicamentos"
                                  defaultValue={this.state.caidas.medicamentos}
                                  value={this.state.caidas.medicamentos}
                                  onChange={(e) => {
                                    this.setCaida2CaPr(e.target.value);
                                  }}
                                >
                                  <FormControlLabel
                                    value="Sí"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="Sí"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </td>
                          </tr>
                          <tr
                            style={{
                              lineHeight: 1,
                              borderTop: "1px solid #6c757d",
                            }}
                          >
                            <td
                              style={{
                                padding: 9,
                                fontSize: "1rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                fontWeight: 400,
                              }}
                            >
                              Deficits Sensoriales
                            </td>
                            <td style={{ padding: 2 }}>
                              <FormControl component="fieldset">
                                <RadioGroup
                                  aria-label="Medicamentos"
                                  name="medicamentos"
                                  defaultValue={
                                    this.state.caidas.def_sensoriales
                                  }
                                  value={this.state.caidas.def_sensoriales}
                                  onChange={(e) => {
                                    this.setCaida3CaPr(e.target.value);
                                  }}
                                >
                                  <FormControlLabel
                                    value="Alteraciones Visuales, Auditivas"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="Alteraciones Visuales, Auditivas"
                                  />
                                  <FormControlLabel
                                    value="Ninguno"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="Ninguno"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </td>
                          </tr>
                          <tr
                            style={{
                              lineHeight: 1,
                              borderTop: "1px solid #6c757d",
                            }}
                          >
                            <td
                              style={{
                                padding: 9,
                                fontSize: "1rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                fontWeight: 400,
                              }}
                            >
                              Estado mental
                            </td>
                            <td style={{ padding: 2 }}>
                              <FormControl component="fieldset">
                                <RadioGroup
                                  aria-label="Medicamentos"
                                  name="medicamentos"
                                  defaultValue={this.state.caidas.estado_mental}
                                  value={this.state.caidas.estado_mental}
                                  onChange={(e) => {
                                    this.setCaida4CaPr(e.target.value);
                                  }}
                                >
                                  <FormControlLabel
                                    value="Orientado"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="Orientado"
                                  />
                                  <FormControlLabel
                                    value="Confuso"
                                    control={<Radio color="primary" />}
                                    disabled={this.state.disableFormFalling}
                                    label="Confuso"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </td>
                          </tr>
                          <tr
                            style={{
                              lineHeight: 1,
                              borderTop: "1px solid #6c757d",
                            }}
                          >
                            <td
                              style={{
                                padding: 9,
                                fontSize: "1rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                fontWeight: 400,
                              }}
                            >
                              El Paciente deambula normalmente de manera segura
                              y sin ayuda
                            </td>
                            <td style={{ padding: 2 }}>
                              <ThemeProvider theme={theme}>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    aria-label="Medicamentos"
                                    name="medicamentos"
                                    defaultValue={
                                      this.state.caidas.deambulacion
                                    }
                                    value={this.state.caidas.deambulacion}
                                    onChange={(e) => {
                                      this.setCaida5CaPr(e.target.value);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="Sí"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="Sí"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </ThemeProvider>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      ></div>
                    </div>
                  </div>
                </div>
              </Row>
            </>
          ) : null}
          <Row>
            {this.state.edit_reqEspeciales ? (
              <>
                <Col>
                  <div style={{ margin: 5 }}>
                    <FormGroup style={{ width: "100%", margin: 5 }}>
                      <Row style={{ magin: 0, padding: 0 }}>
                        <Col md={4}>
                          <FontAwesomeIcon
                            icon={faPlusSquare}
                            style={{
                              margin: "0px 5px 0px 5px",
                              width: 30,
                              color: "#1086e0",
                            }}
                          />
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                color="default"
                                disabled={this.state.disableEspReqForm}
                                checked={
                                  this.state.requerimientos_especiales
                                    .hospitalizado
                                }
                                onChange={(e, checked) => {
                                  this.setReqHospitalizado(checked);
                                }}
                              />
                            }
                            label="Hospitalizado"
                          />
                        </Col>
                        <Col md={4}>
                          <FontAwesomeIcon
                            icon={faWheelchair}
                            style={{
                              margin: "0px 5px 0px 5px",
                              width: 30,
                              color: "#1086e0",
                            }}
                          />
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                checked={
                                  this.state.requerimientos_especiales.sillas
                                }
                                disabled={this.state.disableEspReqForm}
                                onChange={(e, checked) => {
                                  this.setReqSillas(checked);
                                }}
                                color="default"
                              />
                            }
                            label="Sillas de ruedas"
                          />
                        </Col>
                        <Col md={4}>
                          <FontAwesomeIcon
                            icon={faHeadSideCough}
                            style={{
                              margin: "0px 5px 0px 5px",
                              width: 30,
                              color: "#1086e0",
                            }}
                          />
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                color="default"
                                onChange={(e, checked) => {
                                  this.setReqSintomas(checked);
                                }}
                                checked={
                                  this.state.requerimientos_especiales
                                    .sintomas_respiratorios
                                }
                                disabled={this.state.disableEspReqForm}
                              />
                            }
                            label="Sintomas respitarios (Covid)"
                          />
                        </Col>
                      </Row>
                      <Row style={{ magin: 0, padding: 0 }}>
                        <Col md={4}>
                          <FontAwesomeIcon
                            icon={faLungs}
                            style={{
                              margin: "0px 5px 0px 5px",
                              width: 30,
                              color: "#1086e0",
                            }}
                          />
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                color="default"
                                onChange={(e, checked) => {
                                  this.setReqOxigeno(checked);
                                }}
                                checked={
                                  this.state.requerimientos_especiales.oxigeno
                                }
                                disabled={this.state.disableEspReqForm}
                              />
                            }
                            label="Oxigeno"
                          />
                        </Col>
                        <Col md={4}>
                          <FontAwesomeIcon
                            icon={faProcedures}
                            style={{
                              margin: "0px 5px 0px 5px",
                              width: 30,
                              color: "#1086e0",
                            }}
                          />
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                color="default"
                                onChange={(e, checked) => {
                                  this.setReqCamilla(checked);
                                }}
                                checked={
                                  this.state.requerimientos_especiales.camilla
                                }
                                disabled={this.state.disableEspReqForm}
                              />
                            }
                            label="Camilla"
                          />
                        </Col>
                        <Col md={4}>
                          <FontAwesomeIcon
                            icon={faAmbulance}
                            style={{
                              margin: "0px 5px 0px 5px",
                              width: 30,
                              color: "#1086e0",
                            }}
                          />
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                color="default"
                                onChange={(e, checked) => {
                                  this.setReqAmbulancia(checked);
                                }}
                                checked={
                                  this.state.requerimientos_especiales
                                    .ambulancia
                                }
                                disabled={this.state.disableEspReqForm}
                              />
                            }
                            label="Ambulancia"
                          />
                        </Col>
                      </Row>
                      <Row style={{ magin: 0, padding: 0 }}>
                        <Col md={4}>
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                color="default"
                                onChange={(e) => {
                                  this.setReqNinguno(e.target.checked);
                                }}
                                checked={
                                  this.state.requerimientos_especiales.ninguno
                                }
                                //disabled={this.state.disableEspReqForm}
                              />
                            }
                            label="Ninguno"
                            style={{ marginLeft: 30 }}
                          />
                        </Col>
                        <Col md={4}>
                          <FormControlLabel
                            control={
                              <MedicalCheckbox
                                color="default"
                                onChange={(e) => {
                                  this.setReqOtro(e.target.checked);
                                }}
                                checked={
                                  this.state.requerimientos_especiales.otro
                                }
                                disabled={this.state.disableEspReqForm}
                              />
                            }
                            label="Otro"
                            style={{ marginLeft: 30 }}
                          />
                        </Col>
                        <Col md={4}>
                          {this.state.requerimientos_especiales.otro == true ? (
                            <TextField
                              id="another_requiriment"
                              label="Otro Requerimiento"
                              type="text"
                              style={{ marginLeft: 30 }}
                              //disabled={disableFormAdm}
                              value={
                                this.state.requerimientos_especiales.otroReq
                              }
                              onChange={(e) => {
                                this.setReqOtroReq(e.target.value);
                              }}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </FormGroup>
                  </div>
                </Col>
                <Tooltip title="Guardar Cambios">
                  <IconButton
                    aria-label="upload picture"
                    component="span"
                    style={{ height: "1rem", width: "auto" }}
                    onClick={() => {
                      this.updateReqEsp();
                    }}
                  >
                    <SaveIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Cancelar">
                  <IconButton
                    aria-label="upload picture"
                    component="span"
                    style={{ height: "1rem", width: "auto" }}
                    onClick={() => {
                      this.setState({ edit_reqEspeciales: false });
                    }}
                  >
                    <BlockIcon />
                  </IconButton>
                </Tooltip>
              </>
            ) : null}
          </Row>
        </Row>
        {/* {infoPatient !== null && infoPatient !== undefined ?
                    this.state.showClinicHistoryComplete ? <ModalHistory data={infoPatient} openModal={this.state.showClinicHistoryComplete} setOpenModal={this.handlerShowClinicHistoryComplete} /> : null
                    : null} */}

        {this.state.openModalAlergies && this.props.infoPatient ? (
          <AlergiesListToShow
            id_historia={this.props.infoPatient.id_historia}
            openModaAlergie={this.state.openModalAlergies}
            handlerOpenModalAlergies={this.handlerOpenModalAlergies}
          />
        ) : null}
        {this.state.showClinicHistoryComplete ? (
          <Modal
            open={this.state.showClinicHistoryComplete}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
          >
            <div
              className="paperAppointment-flex"
              style={{ width: "90%", margin: 10 }}
            >
              <IconButton
                style={{ float: "right" }}
                onClick={() => {
                  this.setState({ showClinicHistoryComplete: false });
                }}
              >
                <CloseIcon />
              </IconButton>
              <div className="container-pdfs-modal">
                <iframe
                  className="iframe-pdfs"
                  id="pdfV"
                  title="pdf-report"
                ></iframe>
              </div>
            </div>
          </Modal>
        ) : null}
      </Fragment>
    );
  }
}

export default PatientInformation;
